import store from 'store';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:9000/';
export const baseURL = apiUrl.endsWith('/') ? apiUrl : `${apiUrl}/`;

export const isEmail = email => /^[a-z0-9._%+-]+@.+\..+/.test(email);

export const createHash = (arr, key) => {
  var Hash = function () {
    this.data = {};
    if (arr && Array.isArray(arr)) {
      arr.forEach(o => {
        this.data[o[key]] = o;
      });
      this.size = arr.length;
    } else {
      this.size = 0;
    }
  };
  Hash.prototype.keys = function () {
    return Object.keys(this.data);
  };
  Hash.prototype.values = function () {
    return Object.values(this.data);
  };

  return new Hash();
};

// @deprecated: Use object.image_url property instead. These functions are kept for backward compatibility.
export const getCategoryImageUrl = id => `${baseURL}/files/category-images/${id}`;
export const getProductImageUrl = id => `${baseURL}/files/product-images/${id}`;
export const getTagImageUrl = id => `${baseURL}/files/tag-images/${id}`;
export const getSubcategoryImageUrl = id => `${baseURL}/files/subcategory-images/${id}`;
export const getBrandImageUrl = id => `${baseURL}/files/brand-images/${id}`;

export const getImageFallbackUrl = (originalUrl) => {
  if (!originalUrl) return originalUrl;

  // If the URL contains menus-media domain and fails, try foodmenuapi domain
  if (originalUrl.includes('menus-media.elements-creative.com')) {
    return originalUrl.replace(
      'https://menus-media.elements-creative.com',
      'https://foodmenuapi.elements-creative.com'
    );
  }

  // If the URL contains foodmenuapi domain and fails, try menus-media domain
  if (originalUrl.includes('foodmenuapi.elements-creative.com')) {
    return originalUrl.replace(
      'https://foodmenuapi.elements-creative.com',
      'https://menus-media.elements-creative.com'
    );
  }

  // For localhost development, try menus-media as fallback
  if (originalUrl.includes('localhost:9000') || originalUrl.includes('localhost:5000')) {
    return originalUrl.replace(/https?:\/\/localhost:\d+/, 'https://menus-media.elements-creative.com');
  }

  // Return original URL if no fallback is applicable
  return originalUrl;
};

export const getPrimaryImageUrl = (originalUrl) => {
  if (!originalUrl) return originalUrl;

  // Convert any foodmenuapi URLs to menus-media URLs for primary loading
  if (originalUrl.includes('foodmenuapi.elements-creative.com')) {
    return originalUrl.replace(
      'https://foodmenuapi.elements-creative.com',
      'https://menus-media.elements-creative.com'
    );
  }

  // Return original URL if it's already using the correct domain
  return originalUrl;
};

/**
 * Get user data from localStorage; returns null if missing/failed
 */
export const getUserData = () => {
  try {
    const data = store.get('user');
    if (!data) {
      return null;
    }
    return data;
  } catch (error) {
    console.warn('Failed to get user data:', error);
    return null;
  }
};

/**
 * Get menu ID from stored user data; returns null if missing
 */
export const getMenuId = () => {
  const userData = getUserData();
  if (!userData?.id) {
    return null;
  }
  return userData.id;
};
